import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Nights lost searching for sequences that work, flow, and fit your specific athletes', 'Classes that feel repetitive — because you keep falling back on what you already know', 'Visible improvisation that quietly chips away at your confidence as a coach', 'No variety across weeks — and athletes who slowly lose motivation without knowing why', 'Weekends spent planning instead of resting, recovering, or living your life'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-base" data-id="element-156" data-mp="220waoakmqkr0">
      <div className="max-w-3xl mx-auto" data-id="element-157" data-mp="1nztq629a9ii7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-158" data-mp="1o14sryqzsk7q">
          <h2 className="text-3xl md:text-4xl font-display font-extrabold mb-6 text-ink" data-id="element-159" data-mp="3nd7m00pf4syl">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-graphite leading-relaxed bg-cream-light p-6 rounded-2xl border border-silver-light text-left" data-id="element-160" data-mp="1yz3y31ns6aif">
            Sunday night. 10 PM. Tomorrow morning you have a Ninja class. And you&apos;re still
            there, searching online, trying to build a session that really flows — that fits your
            athletes, that feels professional, that doesn&apos;t look like you threw it together in
            twenty minutes.
            <br data-id="element-161" data-mp="1b39aja031t7g" />
            <br data-id="element-162" data-mp="1b3rgwzgglnt3" />
            <span className="text-brand-dark font-semibold" data-id="element-163" data-mp="1b4an5iwqynra">
              Not because you don&apos;t know Ninja.
            </span>{' '}
            Because nobody ever gave you a complete, ready-to-teach system. You&apos;ve been
            building every class from scratch. The time you should be resting — you&apos;re spending
            it planning. And the worst part isn&apos;t the exhaustion. The worst part is walking into
            the gym feeling like you could have been better prepared.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="space-y-6" data-id="element-164" data-mp="1t7htgo2fbcal">
          <h3 className="text-xl font-bold text-ink mb-8 text-center" data-id="element-165" data-mp="273mvbxjg9ua6">
            The real cost of not having the right resource:
          </h3>
          <ul className="space-y-4" data-id="element-166" data-mp="1acuf8zwio28e">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-4 bg-white p-4 rounded-xl border border-silver-light" data-id="element-167" data-mp="1ee62iyrx4bdf" data-mpi={index}>
                <span className="text-brand mt-1" aria-hidden="true" data-id="element-168" data-mp="vner7rodeawe">
                  🔴
                </span>
                <span className="text-graphite" data-id="element-169" data-mp="j7ezt5ki16ja">{point}</span>
              </motion.li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-silver-light" data-id="element-170" data-mp="e7j3lsi1mjea">
            <p className="text-2xl font-display font-extrabold text-brand" data-id="element-171" data-mp="a6qwp5wn8ql6">
              Stop giving away your free time. Your dedication is already there. What you need now is
              the right tool.
            </p>
            <p className="text-xl mt-4 text-ink" data-id="element-172" data-mp="ge0ggfgv8z7">Plan more than 150 Ninja classes today.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}